export default __webpack_public_path__ + "static/avenir-next-bold-711a4eb654bf1139f123726719956a35.otf";